/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { PeopleProfilePhotoUrlResponseUrl } from './peopleProfilePhotoUrlResponseUrl';

/**
 * Short-lived SAS URL for the owner's profile photo.
 */
export interface PeopleProfilePhotoUrlResponse {
  url?: PeopleProfilePhotoUrlResponseUrl;
}
